import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analyticsService';

/**
 * Percorso da inviare ad Analytics. /accesso-ticket e le sue varianti legacy
 * (/accesso-ticket/<token>) portano un token di accesso: si invia solo
 * /accesso-ticket, mai il token. Il link universale /t/<numero> invia solo /t
 * (niente numeri di ticket in Analytics).
 */
export const analyticsPath = (pathname: string): string => {
  if (pathname === '/accesso-ticket' || pathname.startsWith('/accesso-ticket/')) return '/accesso-ticket';
  if (pathname === '/t' || pathname.startsWith('/t/')) return '/t';
  return pathname;
};

/** Traccia un page view a ogni cambio di route (solo il percorso ripulito). */
export const usePageViewTracking = (): void => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(analyticsPath(location.pathname));
  }, [location]);
};
